import type { Schema } from '@dealdesk/api-schema';
import { z } from 'zod';

import { M } from '@/business';

export const employerSchema = z.object({
  name: z.string({ error: M.required }).trim().min(2, M.required),
  nameAr: z.string().optional(),
  emirate: z.string().optional(),
  freeZone: z.boolean(),
  industry: z.string().optional(),
  tradeLicenseNo: z.string().optional(),
  aliases: z.string().optional(),
});
export type EmployerValues = z.infer<typeof employerSchema>;

export const toEmployerValues = (e?: Schema<'Employer'>): EmployerValues => ({
  name: e?.name ?? '',
  nameAr: e?.nameAr ?? '',
  emirate: e?.emirate ?? '',
  freeZone: e?.freeZone ?? false,
  industry: e?.industry ?? '',
  tradeLicenseNo: e?.tradeLicenseNo ?? '',
  aliases: e?.aliases.join('\n') ?? '',
});

/** One alias per line; blanks dropped. Aliases let imports and search match other spellings. */
export const toEmployerInput = (v: EmployerValues): Schema<'EmployerInput'> => ({
  name: v.name.trim(),
  nameAr: v.nameAr?.trim() || null,
  emirate: v.emirate?.trim() || null,
  freeZone: v.freeZone,
  industry: v.industry?.trim() || null,
  tradeLicenseNo: v.tradeLicenseNo?.trim() || null,
  aliases: (v.aliases ?? '').split('\n').map((a) => a.trim()).filter(Boolean),
});
